export const STAMPS_CREDENTIALS_FIELDS = {
  USERNAME: 'username',
  PASSWORD: 'password',
};
